import { render } from "./pinned-message-removal-modal.vue?vue&type=template&id=10089e9b"
import script from "./pinned-message-removal-modal.vue?vue&type=script&lang=js"
export * from "./pinned-message-removal-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__